import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(private httpClient: HttpClient) { }

  PostOrder(_model) {
    return this.httpClient.post<any>(environment.apiBaseUrl + 'api/CustomerOrders/PostOrder', _model);
  }

  sendContact(_model) {
    return this.httpClient.post<any>(environment.apiBaseUrl + 'api/Contact/contactus', _model);
  }

  shareOrder(_model) {
       const payload = {
      sendTo: 'dashdj.singh@gmail.com',
      data: _model,
    };
      return this.httpClient.post<any>(environment.apiBaseUrl + 'api/CustomerOrders/ShareCartDetails', _model);
    }
}
